import { Component } from '@angular/core';
import { ADBInfo, DBPanelInfo } from '../../../../../models/datamodel/adbinfo.model';
import { BaseDataSourcePanel } from '../../../../../settings/datamodel/datasource/datasourcepanels/basedatasource.panel';

@Component({
    selector: 'db2-panel',
    templateUrl: './db2.panel.html',
    styleUrls: ['./db2.panel.css']
})
export class DB2Panel extends BaseDataSourcePanel {
    static GetInfo(): DBPanelInfo {
        return {
            ControlType: DB2Panel,
            DBInfoType: DB2DBInfo
        };
    }

    constructor() {
        super();
        this.DBInfoType = DB2DBInfo;
    }
}

export class DB2DBInfo extends ADBInfo {
    Server;
    Database;
    Username;
    Port;
    Password;
    SSPI = false;
    Timeout = 30;

    getTypeName(): string {
        return 'evidanza.Database.DB2Impl.DB2DBInfo';
    }
}
